var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIPhoneSe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0483398,
    y: 0.561035,
    width: 20.7477,
    height: 20.7477,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_87_275",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_87_275",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAACHUlEQVR4nO2dO04DQRAFXwQcgd8RMWRANhNwAS7FJwKOgkxCVGhXBEhGAozl3YJ+UieOqp5as846qVQqlXmFlj16zui5p+WFHmY1A1PLHS2nXGc3xtByTM/T5GX2b5f+ODBHuMmekvuHsk2b/f5cIJ1FLBnf5OkLY825jSX0LGdQGGvOMpbMoCx+M7Fk6qKoojN5if9iozOzWDj1Akg49QJIOPUCSDj1Akg49QJIOPUCSDj1Akg49QJIOPUCSDj1Akg49QJIOPUCSDj1Akg49QJIOPUCSDj1Akg49QJIOPUCSDj1Akg49QJIOPUCSDj1Akg49QJIOPUCSDj1Akg49QJIOPUCSDj1Akg49QJIOPUCSDj1Akg49QJIOPUCSDj1Akg49QJIOPUCSDj1Akg49QJIOPUCSDj1Akg49QJIOPUCSDj1Akg49QJIOPUCSDj1Akg49QJIOPUCSDj1Akg49QJIOPUCSDj1Akg49QJIOPUCSDj1Akg49QJIOPUCSDj1Akg49QJIOH8sgGRiydRFUUVn8hJro/uXJbzSck7L4Tg9F+NvVfTGN+3ikydqKLs2eqMlXOVgpeiW/Sp605vWcrhS9FWOquhtPB0tl1X05ot+Hd/k+hj+mYM3z7GkTjhtKeN9wOk3k7Wm5SSWDKfqxpN1U5fWfzwPtOxEdzjSVfbD8Hcxxoyb3bMYTtfN9AO5pOVmeC50m1ypVPIP8gZ2I9XgWU3LXAAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIPhoneSe);
export default __webpack_public_path__ + "static/media/iPhone_SE.1c58e6b0d3156318fa2bb9ec6d153b5f.svg";
export { ForwardRef as ReactComponent };